import { createQueryHook } from '@hooks/createQueryHook'
import { createMutationHook } from '@hooks/createMutationHook'

// Current provably-fair seeds. No params.
export const usePlayerSeeds = createQueryHook('provablyFair.seeds')

// Recompute a crash multiplier. Component passes { hash, seed }; runs only once
// both are set (on-demand verify).
export const useVerifyFairness = createQueryHook('provablyFair.verify')

// Fairness info for a finished round. Component passes { roundId }.
export const useRoundInfo = createQueryHook('provablyFair.roundInfo')

// Live commitment for the active global server seed + algorithm parameters.
// Component passes { gameCode, gameMode }.
export const useActiveProvablyFair = createQueryHook('provablyFair.active')

// Rotate the client seed (mutation). Refreshes seeds on success.
// Usage: const { mutate } = useUpdateClientSeed(); mutate({ clientSeed })
export const useUpdateClientSeed = createMutationHook('provablyFair.updateClientSeed')
